import React from "react";

const WhyChooseUsNew = () => {
  const features = [
    {
      image: "/d1.png",
      title: "Fast Loan Processing",
      description: "Our streamlined digital application ensures quick approvals without unnecessary paperwork. Most customers receive verification updates within 24-48 hours, helping you access funds when you need them the most."
    },
    {
      image: "/d2.png",
      title: "Intelligent Credit Evaluation",
      description: "Our smart credit assessment technology analyzes financial data responsibly to provide fair and transparent loan decisions, ensuring customers receive offers tailored to their financial profile."
    },
    {
      image: "/d3.png",
      title: "Secure & Protected Financial Data",
      description: "Your personal and financial information is safeguarded using modern security protocols and encrypted systems, ensuring a safe and confidential borrowing experience."
    },
    {
      image: "/d4.png",
      title: "Dedicated Financial Assistance",
      description: "Our experienced advisors provide personalized support at every step from application to approval helping you choose the right financial solution with confidence."
    }
  ];

  return (
    <section className="relative w-full py-12 md:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            <span className="text-slate-800">Why Thousands Choose </span>
            <span className="text-blue-600">Pawan Sut Finance</span>
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            From faster approvals to expert financial guidance, our lending solutions are designed to make borrowing simple, secure, and stress-free for individuals and growing businesses.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="flex flex-wrap lg:flex-nowrap justify-center gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 w-full md:w-[320px] lg:w-[320px] md:h-[464px] flex-shrink-0 flex flex-col"
            >
              {/* Image */}
              <div className="overflow-hidden w-full md:w-[321px] md:h-[171px]">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="p-5 md:p-6 text-left flex flex-col flex-grow">
                {/* Title */}
                <h3 className="text-lg md:text-xl font-bold text-slate-800 mb-4 leading-tight">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="text-sm md:text-base text-slate-600 leading-relaxed flex-grow">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsNew;

